import { Segment, Station, Timestamp } from '@mi-front/core';
import { HoverStatusThumbnail } from './HoverStatusThumbnail';
import { LatestStatusThumbnail } from './LatestStatusThumbnail';

interface Props {
  readonly station: Station;
  readonly segments: readonly Segment[];
  readonly hoveredTs?: Timestamp | null;
}

/**
 * Status thumbnail component that displays a thumbnail for video stations.
 * When hoveredTs is provided, shows the hover thumbnail for that timestamp.
 * Otherwise, shows the latest thumbnail (first segment start).
 */
export function StatusThumbnail(p: Props) {
  const { station, segments, hoveredTs } = p;

  if (hoveredTs) {
    return <HoverStatusThumbnail station={station} ts={hoveredTs} segments={segments} />;
  }

  return <LatestStatusThumbnail station={station} segments={segments} />;
}
